import { remove_Info, add_Info, remove_InfoGroup } from "../../actions/actionConstants";

const updateInfos = (state, action) => {
    if (state === undefined) {
        return {
            messages: [
                // {
                //     group: "",
                //     type: "",
                //     id: -1,
                //     text: "aaa sss ss"
                // }
            ]
        };
    }
    switch (action.type) {
        case remove_Info: {
            const id = action.payload;
            const prevs = state.app.infoMessages.messages;
            return {
                messages: prevs.filter(_m => _m.id !== id)
            };
        }
        case remove_InfoGroup: {
            const prevs = state.app.infoMessages.messages;
            const group = action.payload;
            return {
                messages: prevs.filter(_i => _i.group !== group)
            };
        }
        case add_Info: {
            const prevs = state.app.infoMessages.messages;
            return {
                messages: [...prevs, action.payload]
            };
        }
        default:
            return state.app.infoMessages;
    }
};

export default updateInfos;
